module.exports = __webpack_public_path__ + "./fonts/69a95ac5428e35f5f156a71e62115f14.woff2";